import { FlexBox } from '@fable/components'
import { css, cx } from '@fable/theme'
import { useChartData } from '../hooks/useChartData'
import { useState } from 'react'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const ChartXAxis = () => {
  const theme = useStatsTheme((s) => s.theme)
  const { covers } = useChartData()
  const [loadedImages, setLoadedImages] = useState<number[]>([])

  const handleImageLoad = (index: number) => {
    setLoadedImages((prev) => [...prev, index])
  }

  return (
    <FlexBox
      className={css`
        width: calc(100% - 2px);
        gap: 10px;
        position: relative;
        left: 1px;
        align-items: center;
        justify-content: ${covers.length === 1 ? 'center' : 'space-between'};
      `}
      alignItems="center"
      justifyContent="space-between"
    >
      {covers.map((cover, i) => (
        <FlexBox
          key={i}
          className={cx(
            'anim__rating-book',
            css`
              gap: 8px;
              opacity: 0;
              transform: translateY(10px);
              will-change: transform, opacity;
            `
          )}
          flexDirection="column"
          alignItems="center"
        >
          <span
            className={css`
              display: block;
              width: 1px;
              height: 2px;
              background-color: ${theme.colors.section.textSecondary};
            `}
          />
          <div
            className={css`
              width: 18px;
              height: 26px;
              background-color: ${theme.colors.section.bg};
              border-radius: 2px;
              overflow: hidden;
            `}
          >
            {!!cover.length ? (
              <img
                className={css`
                  display: block;
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: center;
                  opacity: ${loadedImages.includes(i) ? 1 : 0};
                `}
                src={cover}
                alt="book cover"
                onLoad={() => handleImageLoad(i)}
              />
            ) : null}
          </div>
        </FlexBox>
      ))}
    </FlexBox>
  )
}
